/**
 * マイルストーン表示に関わる重なり順。
 *
 * 数値を個別のファイルに散らすと前後関係が追えなくなるため、1か所にまとめている。
 * 行のマーカー (GanttBackground) は、ヘッダーの名称ポッパーより手前・ピン留めヘッダー
 * より奥に収める。これより大きくすると、イナズマ線表示中は行のスタッキングコンテキストが
 * 外れるため、ダイアログや列設定 (いずれも z-index: 1300) の上に突き抜ける。
 */
export const GanttMilestoneZIndex = {
  // ヘッダーの名称ポッパー。セルの並び順ぶんだけ加算する。
  NAME_POPPER_BASE: 200,
  // 名称ポッパーをクリックで前面化したときの上限。
  NAME_POPPER_FOCUS_MAX: 900,
  // 行のマーカー。
  ROW_MARKER: 910,
  // 行のマーカーをクリックで前面化したとき。
  ROW_MARKER_FOCUS: 920,
  // ピン留めヘッダー。名称ポッパーと行のマーカーの両方を覆い隠す。
  PINNED_HEADER: 950,
} as const
